export default ({ store, app }) => {
  const defaultSaved = store.state.geolocation.defaultSaved;

  // nuxtServerInit already handled this on the server, skip
  if (defaultSaved) {
    store.commit("geolocation/SET_REGION_READY", true);
    return;
  }

  // Fallback: populate from cookies client-side if SSR didn't run
  // (e.g. static generation, or cookie wasn't available server-side)
  const g = {
    "GBP": 'TEFLORG',
    "USD": "TEFLUS",
    "EUR": "IRELAND",
    "CAD": "CANADA",
    "AUD": "AUSTRALIA",
    "ZAR": "SOUTHAFRICA"
  };

  const timezone = app.$cookies.get('tefl_geolocation_timezone') || '';
  const city = app.$cookies.get('tefl_geolocation_city') || '';
  const country = app.$cookies.get('tefl_geolocation_country') || '';
  const region = app.$cookies.get('tefl_geolocation_region') || '';
  const currency = app.$cookies.get('tefl_geolocation_currency') || '';

  store.commit("geolocation/SET_GEOLOCATION", {
    detectedTimezone: timezone,
    detectedCity: city,
    detectedCountry: country,
    detectedRegion: region,
    detectedCurrency: currency,
  });

  const priceLabel = g[currency] || 'TEFLORG';
  store.commit("cart/setPriceLabel", priceLabel);
  store.commit("geolocation/SET_DEFAULT", true);
  store.commit("geolocation/SET_REGION_READY", true);
}